export const pl = {
  serviceVendorForm: {
    nameLabel: 'Nazwa firmy',
    nameRequired: 'Nazwa firmy jest wymagana',
    streetLabel: 'Ulica',
    streetRequired: 'Ulica jest wymagana',
    cityLabel: 'Miejscowość',
    cityRequired: 'Miejscowość jest wymagana',
    postalCodeRequired: 'Kod pocztowy jest wymagany',
    postalCodeInvalid: 'Kod pocztowy musi mieć format XX-XXX',
    emailRequired: 'Email jest wymagany',
    emailInvalid: 'Nieprawidłowy format email',
    websiteInvalid: 'Nieprawidłowy format URL (wymagane http:// lub https://)',
    descriptionLabel: 'Opis',
    serviceTypeRequired: 'Typ usługi jest wymagany',
    termsRequired: 'Akceptacja regulaminu jest wymagana',
    representationRequired: 'Oświadczenie jest wymagane',
  },
  profileEditForm: {
    title: 'Edytuj profil',
    namePlaceholder: 'Wprowadź nazwę firmy',
    emailLabel: 'Email',
    emailPlaceholder: 'np. kontakt@firma.pl',
    phoneLabel: 'Telefon',
    phonePlaceholder: 'np. +48 123 456 789',
    websiteLabel: 'Strona internetowa',
    websitePlaceholder: 'np. https://www.firma.pl',
    descriptionPlaceholder: 'np. Prosimy o przybycie 10 minut przed wizytą. Parking od strony podwórza.',
    descriptionHint: 'Maks. 1000 znaków. Opis zobaczą klienci w aplikacji PETSEO.',
    reset: 'Cofnij zmiany',
    submit: 'Zapisz zmiany',
    submitting: 'Zapisywanie...',
  },
  profileDetailsPage: {
    title: 'Szczegóły profilu',
    loadError: 'Wystąpił błąd podczas pobierania profilu. Spróbuj ponownie później.',
    detailsTab: 'Szczegóły',
    galleryTab: 'Galeria',
    servicesTab: 'Usługi',
    hoursTab: 'Godziny otwarcia',
    employeesTab: 'Pracownicy',
    editTab: 'Edycja',
  },
  serviceForm: {
    createTitle: 'Dodaj nową usługę',
    editTitle: 'Edytuj usługę',
    nameLabel: 'Nazwa usługi',
    namePlaceholder: 'np. Strzyżenie psa',
    nameRequired: 'Nazwa usługi jest wymagana',
    durationLabel: 'Czas trwania',
    durationMin: 'Minimalny czas trwania to 15 minut',
    durationMax: 'Maksymalny czas trwania to 8 godzin',
    durationStep: 'Czas musi być wielokrotnością 15 minut',
    withoutPriceDescription: 'Klient nie zobaczy ceny tej usługi.',
    priceModeLabel: 'Cena',
    priceModeFixed: 'Stała',
    priceModeFrom: 'Od (orientacyjna)',
    priceModeNone: 'Bez ceny',
    pricePreview: 'Klient zobaczy:',
    priceLabel: 'Cena (PLN)',
    pricePlaceholder: 'np. 150',
    priceRequired: 'Cena jest wymagana',
    pricePositive: 'Cena musi być większa od 0',
    priceMax: 'Maksymalna cena to 100 000 PLN',
    submit: 'Zapisz',
    submitting: 'Zapisywanie...',
  },
  serviceFormatting: {
    unnamedVendor: 'Brak nazwy',
    minutes: 'min',
    currency: 'zł',
    priceFrom: 'od',
  },
  servicesTable: {
    nameHeader: 'Nazwa usługi',
    durationHeader: 'Czas trwania',
    priceHeader: 'Cena',
    statusHeader: 'Status',
    active: 'Aktywna',
    inactive: 'Nieaktywna',
    edit: 'Edytuj',
    deactivate: 'Dezaktywuj',
    restore: 'Przywróć',
  },
  reservationCard: {
    unknownClient: 'Nieznany klient',
    unknownService: 'Nieznana usługa',
    externalBadge: 'Zewnętrzna',
    dateLabel: 'Data:',
    timeLabel: 'Godzina:',
    priceLabel: 'Cena:',
    employeeLabel: 'Pracownik:',
    details: 'Szczegóły',
    confirm: 'Potwierdź',
    reject: 'Odrzuć',
    noShow: 'Nieobecność',
  },
  reservationDetails: {
    title: 'Szczegóły rezerwacji',
    externalBadge: 'Rezerwacja zewnętrzna',
    clientLabel: 'Klient',
    clientPhoneLabel: 'Telefon klienta',
    clientEmailLabel: 'Email klienta',
    petLabel: 'Pupil',
    unknownPet: 'Nieznany pupil',
    serviceLabel: 'Usługa',
    unknownService: 'Nieznana usługa',
    employeeLabel: 'Pracownik',
    unassignedEmployee: 'Nieprzypisany',
    dateLabel: 'Data',
    timeLabel: 'Godzina',
    durationLabel: 'Czas trwania',
    durationUnit: 'minut',
    priceLabel: 'Cena',
    noShowRateLabel: 'Wskaźnik nieobecności klienta',
    noShowRateTooltip:
      'Procent rezerwacji, na które klient się nie stawił, w stosunku do wszystkich zakończonych rezerwacji. W nawiasie: liczba nieobecności / liczba zakończonych rezerwacji.',
    notesLabel: 'Notatki',
  },
  scheduleForm: {
    createTitle: 'Dodaj grafik',
    editTitle: 'Edytuj grafik',
    noBusinessHoursTitle: 'Brak uzupełnionych godzin pracy',
    noBusinessHoursMessage: 'Brak zdefiniowanych godzin pracy placówki (uzupełnij aby weryfikować poprawność grafików)',
    outsideBusinessHoursTitle: 'Grafik poza godzinami otwarcia',
    outsideBusinessHoursMessage: 'Dodajesz grafik dla pracownika poza zdefiniowanymi godzinami pracy twojej placówki.',
    validFromLabel: 'Data od',
    validToLabel: 'Data do',
    daysLabel: 'Dni tygodnia',
    blockStartLabel: 'Od',
    blockEndLabel: 'Do',
    addBlock: 'Dodaj blok',
    delete: 'Usuń',
    submit: 'Zapisz',
    deleteConfirmTitle: 'Usuń grafik',
    deleteConfirmMessage: 'Czy na pewno chcesz usunąć ten grafik?',
    deleteConfirmCancel: 'Anuluj',
  },
  weeklySummary: {
    todayReservations: 'Dzisiejsze rezerwacje',
    confirmed: 'Potwierdzone',
    weekRevenue: 'Przychód tygodnia',
  },
} as const;
